import { SERVICES } from "@/config/services";

// Pastille ronde réutilisable affichant le logo officiel COMPLET du service
// (visuel carré réduit à l'intérieur du cercle, rien n'est coupé).
export const ServiceLogo = ({ serviceKey, size = 72, className = "" }) => {
  const svc = SERVICES[serviceKey];
  if (!svc) return null;
  return (
    <div
      data-testid={`service-logo-${serviceKey}`}
      className={`rounded-full bg-white ring-2 ring-white/80 shadow-[0_6px_18px_-4px_rgba(0,0,0,0.35)] flex items-center justify-center overflow-hidden shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={svc.shareImage}
        alt={`Logo ${svc.label}`}
        loading="lazy"
        className="w-[72%] h-[72%] object-contain"
      />
    </div>
  );
};
